import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {Utils} from '@astek/utils';

@Injectable()
export class RestApiService {

  constructor() {
  }

  public get authApiUrl(): string {
    return [window.location.origin, 'auth'].join('/');
  }

  public get apiUrl(): string {
    return [window.location.origin, 'api'].join('/');
  }

  public get clinicalReportApiUrl(): string {
    return [window.location.origin, 'pdf'].join('/');
  }

  public createHttpParams(queryParams: NonNullable<unknown>): HttpParams {
    let params: HttpParams = new HttpParams();
    for (const [param, value] of Object.entries(queryParams)) {
      if (Utils.isNotNullOrUndefined(value)) {
        if (Array.isArray(value)) {
          params = this.appendArrayParam(params, param, value as Array<string | number | boolean>);
        } else {
          params = params.append(param, value as string | number | boolean);
        }
      }
    }
    return params;
  }


  /**
   * HttpParams do not properly append the [] for param array.
   * Add it manually for symfony to properly deserialize array.
   */
  private appendArrayParam(
    httpParams: HttpParams,
    paramName: string,
    values: Array<string | number | boolean>,
  ): HttpParams {
    values.forEach(value => {
      httpParams = httpParams.append(paramName + '[]', value);
    });
    return httpParams;
  }
}
